module.exports = __webpack_public_path__ + "img/Anhänger.db88688f.svg";